const e = {
  id: "NewYorkWin4",
  logo: !0,
  name: "Win 4",
  style: {
    colorPrimary: "#7e0c6e"
  }
};
export {
  e as default
};
